<app-loader></app-loader>
<app-header></app-header>
<ng-container *ngIf="savedRestaurantId">
<router-outlet></router-outlet>
<app-footer></app-footer>
</ng-container>
<app-cookiebar></app-cookiebar>
